import * as styled from '../styles/trust-badges';

const BADGE_ICON: Record<LandingV2.TrustBadgeVariant, string> = {
  gold: '★',
  purple: '◆',
  green: '●',
};

type Props = {
  badges: LandingV2.TrustBadge[];
  accentColor?: string | null;
};

export const TrustBadges = ({ badges, accentColor }: Props) => (
  <styled.BadgeRow>
    {badges.map((badge) => (
      <styled.Badge key={badge.label} $variant={badge.variant} $accentColor={accentColor}>
        {BADGE_ICON[badge.variant]} {badge.label}
      </styled.Badge>
    ))}
  </styled.BadgeRow>
);
